import { connect } from 'react-redux';

import BookingDetails from '../components/Booking/BookingDetails';

function mapStateToProps(state) {
    const { user, person } = state.environment;
    const { persons, costCentres, plant, locations } = state.entities;

    return {
        user,
        person,
        persons,
        costCentres,
        plant,
        locations,
    };
}

export default connect(mapStateToProps)(BookingDetails);



// WEBPACK FOOTER //
// ./scripts/containers/BookingDetailsContainer.jsx